{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "moduleId": "vault",
  "roles": [
    "records-specialist",
    "director-of-maintenance",
    "auditor"
  ],
  "orgTypes": [
    "part-91-owner",
    "corporate-flight-dept",
    "management-company",
    "part-135",
    "integrated-135-145"
  ],
  "extensions": [
    "data-migration",
    "integrations",
    "prebuy"
  ],
  "integrations": [
    "camp",
    "traxxall",
    "sharepoint"
  ]
}